export interface ProfileErrorMessage {
  profileName?: string;
  pinLatitude?: string;
  pinLongitude?: string;
  pinRadius?: string;
  atLeastOnePin?: string;
  addPinBeforeSaveProfile?: string;
}

export const ProfileErrorMessages: ProfileErrorMessage = {
  profileName: 'Profile name must be different from other profiles',
  pinLatitude: 'Latitude must be between -90 and 90',
  pinLongitude: 'Longitude must be between -180 and 180',
  pinRadius: 'Radius must be an integer between 15 and 500',
  atLeastOnePin: 'At least one pin required',
  addPinBeforeSaveProfile: 'Add this pin or discard it before saving the profile',
};
